import {
  VantifyUploadResponse,
  vantifyUploadFile,
} from 'integrations-vantify-api-client';
import { VantifyAuth } from '../common';
import { UploadFileParams } from './types';

export async function uploadFile(
  auth: VantifyAuth,
  params: UploadFileParams
): Promise<VantifyUploadResponse> {
  const { file, filename, contentType } = params;

  if (!file) {
    throw new Error('file is required to upload file');
  }

  if (!filename) {
    throw new Error('filename is required to upload file');
  }

  if (!contentType) {
    throw new Error('contentType is required to upload file');
  }

  return await vantifyUploadFile({
    file,
    filename,
    contentType,
    auth,
  });
}

